import { Component, inject, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { CompaniesService } from '../../../../features/companies/data/services/companies.service';
import { CompanyRegisterRequest } from '../../../../features/companies/data/models/company.models';
import { CommonModule } from '@angular/common';
import { State } from 'country-state-city';

@Component({
  selector: 'app-company-signup',
  standalone: true,
  imports: [RouterLink, ReactiveFormsModule, CommonModule],
  templateUrl: './company-signup.html',
  styleUrl: './company-signup.scss'
})
export class CompanySignup {
  private readonly fb = inject(FormBuilder);
  private readonly companiesService = inject(CompaniesService);
  private readonly router = inject(Router);

  isSubmitting = signal(false);
  errorMessage = signal('');
  showSuccessModal = signal(false);

  signupForm = this.fb.group({
    firstName: ['', [Validators.required]],
    lastName: ['', [Validators.required]],
    companyName: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
    address: ['', [Validators.required]],
    address2: [''],
    phone: ['', [Validators.required]],
    city: ['', [Validators.required]],
    state: ['', [Validators.required]],
    zip: ['', [Validators.required]]
  });

  usStates = State.getStatesOfCountry('US');

  constructor() {}

  onSubmit() {
    if (this.signupForm.invalid) {
      this.signupForm.markAllAsTouched();
      return;
    }

    this.isSubmitting.set(true);
    this.errorMessage.set('');

    const formValue = this.signupForm.getRawValue();
    const payload: CompanyRegisterRequest = {
      firstName: formValue.firstName ?? '',
      lastName: formValue.lastName ?? '',
      companyName: formValue.companyName ?? '',
      email: formValue.email ?? '',
      address: formValue.address ?? '',
      address2: formValue.address2 ?? undefined,
      phone: formValue.phone ?? '',
      city: formValue.city ?? '',
      state: formValue.state ?? '',
      zip: formValue.zip ?? ''
    };

    this.companiesService.registerCompany(payload).subscribe({
      next: (response) => {
        this.isSubmitting.set(false);
        if (response.success) {
          this.showSuccessModal.set(true);
        } else {
          this.errorMessage.set(response.message || 'Registration failed. Please try again.');
        }
      },
      error: (err) => {
        this.isSubmitting.set(false);
        this.errorMessage.set(err?.error?.message || 'Registration failed. Please try again.');
      }
    });
  }

  onSuccessOk() {
    this.showSuccessModal.set(false);
    this.router.navigate(['/auth/login']);
  }
}